import { createTrpcClient } from '@/lib/trpc/base';

type UrlMetadataTrpcClient = ReturnType<typeof createTrpcClient>;

let cachedTrpcClient: UrlMetadataTrpcClient | null = null;

export const getUrlMetadataClient = (): UrlMetadataTrpcClient => {
  if (!cachedTrpcClient) {
    cachedTrpcClient = createTrpcClient();
  }
  return cachedTrpcClient;
};
